exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._DHEAhjdBfuStLBo9auhh{min-height:100vh;position:relative;display:flex}._1Vu-vmqBqcLdOcFcf9BzWE{width:400px;min-height:100vh;box-shadow:0 1px 1px 0 rgba(0,0,0,0.08),0px 1px 6px 1px rgba(0,0,0,0.08);position:relative;z-index:2;padding:20px 20px}._1m0UBu0Vp9kplTNumm2Eyz{flex:1 1;min-width:0;z-index:1}\n", ""]);

// Exports
exports.locals = {
	"top": "_DHEAhjdBfuStLBo9auhh",
	"sidebar": "_1Vu-vmqBqcLdOcFcf9BzWE",
	"content": "_1m0UBu0Vp9kplTNumm2Eyz"
};